import React from 'react';
import PropTypes from 'prop-types';

export default class HelpTips extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isActive: false
        };
    }

    componentDidMount() {
        document.addEventListener('click', this.handleClick, false);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClick, false);
    }

    handleClick = (event) => {
        if (!this.node || !this.node.contains(event.target)) {
            this.setState({isActive: false});
            return true;
        }
        event.preventDefault();
        this.setState({isActive: true});
    };

    render() {
        let classes = 'has-tooltip has-tooltip--bottom margin--10--left';
        if (this.props.isLarge) {
            classes += ' has-tooltip--large';
        }
        if (this.state.isActive) {
            classes += ' is-active';
        }
        return (
            <span className={classes} ref={node => this.node = node} style={{zIndex:this.props.zind}}>
                <span className="question" style={{color:'#fff',backgroundColor:this.props.strobe,boxShadow:'1px 1px 3px #888',height:18,width:18,padding:3}}>{this.props.stage}</span>
                <span className="is-tooltip" style={{width:150,marginLeft:-76,transform:'translateY(14px)',borderRadius: 14,boxShadow: '0px 1px 4px #444',"--left":"50%"}}>
                    {this.props.children}
                </span>
            </span>
        )
    }
}

HelpTips.propTypes = {
    isLarge: PropTypes.bool,
    children: PropTypes.element,
};